export const supportInfo = {
  "cutaquig": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions please call the IgCares Support Center at 833-382-7686. We are fully committed to guiding you through any questions or concerns you may encounter, including if your patient requires:",
    supportItems: [
      { label: "Benefit Verification" },
      { label: "Prior Authorization Support" }
    ],
    footer: "We're here to support you every step of the way and eagerly anticipate the opportunity to assist you.",
  },
  "fibryga": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions please call the Octapharma Support Center toll free at 800-554-4440. We are fully committed to guiding you through any questions or concerns you may encounter, including if your patient requires:",
    supportItems: [
      { label: "Benefit Verification" },
      { label: "Prior Authorization Support" }
    ],
    footer: "We're here to support you every step of the way and eagerly anticipate the opportunity to assist you.",
  },
  "nuwiq": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions, please call the Factor My Way Support Center at 855-498-4260. We are fully committed to guiding you through any questions or concerns you may encounter, including if you need assistance with your patient's benefit verification and/or prior authorization.",
    freeTrial: {
      title: "FREE TRIAL",
      description: "If your patients are currently using another FVIII product, or not yet treating their hemophilia A with a factor therapy, you may want to consider NUWIQ®.",
      details: [
        {
          content: "Eligible Hemophilia A patients can receive treatment with NUWIQ® (not to exceed 6 doses or not exceed approximately 20,000 IUs) at no cost, shipped directly to them and administered under your care and supervision."
        },
        {
          content: "Please call the Factor My Way Support Center at 855-498-4260 for more information."
        }
      ]
    }
  },
  "octagam": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions please call the Octapharma Support Center toll free at 1-800-554-4440. We are fully committed to guiding you through any questions or concerns you may encounter, including if your patient requires:",
    supportItems: [
      { label: "Benefit Verification" },
      { label: "Prior Authorization Support" }
    ],
    footer: "We're here to support you every step of the way and eagerly anticipate the opportunity to assist you.",
  },
  "panzyga": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions please call the Octapharma Support Center toll free at 800-554-4440. We are fully committed to guiding you through any questions or concerns you may encounter, including if your patient requires:",
    supportItems: [
      { label: "Benefit Verification" },
      { label: "Prior Authorization Support" }
    ],
    footer: "We're here to support you every step of the way and eagerly anticipate the opportunity to assist you.",
  },
  "wilate": {
    title: "ADDITIONAL REIMBURSEMENT SUPPORT",
    description: "If you have any questions, please call the Factor My Way Support Center at 855-498-4260. We are fully committed to guiding you through any questions or concerns you may encounter, including if you need assistance with your patient's benefit verification and/or prior authorization.",
    freeTrial: {
      title: "FREE TRIAL",
      details: [
        {
          content: "Eligible VWD patients can receive treatment with wilate (not to exceed 1-3 doses or not to exceed approximately 5,000 IUs) at no cost, shipped directly to them and administered under your care and supervision."
        },
        {
          content: "Please call the Factor My Way Support Center at 855-498-4260 for more information."
        }
      ]
    }
  },
};